import axios from "axios";
import config from "../Config.json";

const fetchUsageData = async (id,data) => {
    try {       

        const AuthToken = localStorage.getItem('token')
        axios.defaults.headers.common['Authorization'] = AuthToken;

        const response = await axios.post(`${config.API_URL}/app/usageStats/${id}`, data)
        return response
    } catch (error) {
        return error
    }
}

export default fetchUsageData;